import "./App.css";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import LeaderBoard from "./components/LeaderBoard";
import Root from "./components/Root";
import ErrorPage from "./components/ErrorPage";
import Question from "./components/Question";
import { loadStudentsActions } from "./store/leaderboard";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import LoginGuard from "./components/LoginGuard";
import Guidelines from "./components/GuideLines";
import Updates from "./components/Updates";
import ViewCode from "./components/ViewCode";
function App() {
  const dispatch = useDispatch();
  // console.log(process.env.REACT_APP_FRONTEND_URL);
  useEffect(() => {
    dispatch(loadStudentsActions());
  }, []);

  useEffect(()=>{
    const interval = setInterval(()=>{
      dispatch(loadStudentsActions());
    }, 4*60*60*1000); // 4 hrs

    return ()=> clearInterval(interval)
  }, [])


  const router = createBrowserRouter([
    {
      path: "/",
      element: <Root />,
      children: [
        {
          index: true,
          element: <LeaderBoard />,
        },
        {
          path: "updates",
          element: (
              <Updates/>
          ),
        },
        {
          path: "rules",
          element: (
              <Guidelines/>
          ),
        },
        {
          path: "question",
          element: (
            <LoginGuard>
              <Question />
            </LoginGuard>
          ),
        },
        {
          path: "view-code/:userId",
          element: (
              <ViewCode />
          ),
        },
      ],
    },
    {
      path: "/500",
      element: <ErrorPage />,
    },
    { path: "*", element: <ErrorPage /> },
  ]);

  return <RouterProvider router={router} />;
}

export default App;
